import { render, staticRenderFns } from "./EditContentItemsPopup.vue?vue&type=template&id=617a9504&scoped=true"
import script from "./EditContentItemsPopup.vue?vue&type=script&lang=js"
export * from "./EditContentItemsPopup.vue?vue&type=script&lang=js"
import style0 from "./EditContentItemsPopup.vue?vue&type=style&index=0&id=617a9504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a9504",
  null
  
)

export default component.exports